import { all, call } from "redux-saga/effects";
import onCreatePaper from "./createPaper";
import onDeletePaper from "./deletePaper";
import onEditPaper from "./editPaper";
import onGetPaper from "./getPapers";
import onGetSinglePaper from "./getSinglePaper";
import onCreatePaperCurriculum from "./createPaperCurriculum";
import onEditPaperCurriculum from "./editPaperCurriculum";

export default function* paperSagas() {
  yield all([
    call(onGetPaper),
    call(onCreatePaper),
    call(onDeletePaper),
    call(onEditPaper),
    call(onGetSinglePaper),
    call(onCreatePaperCurriculum),
    call(onEditPaperCurriculum),
  ]);
}
